export enum ReplaceTypes {
	ReplaceFirstInstance,
	ReplaceAll,
}
